'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UITooltipContent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UITooltipContent(_ref) {
  var className = _ref.className,
      children = _ref.children;

  return _react2.default.createElement(
    'div',
    {
      className: (0, _reactUtils.classNames)('private-tooltip__inner', className),
      role: 'tooltip' },
    children
  );
}

UITooltipContent.propTypes = {
  children: _react.PropTypes.node,
  className: _react.PropTypes.string
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/tooltip/UITooltipContent.js
// module id = 262
// module chunks = 0 1